// extracted by mini-css-extract-plugin
export default {"isInteractive":"styles_isInteractive__NwtKd","name":"styles_name__1WkNw","snippet":"styles_snippet__L7tVv"};